import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Create a deep clone of each emitted object,
 * ensuring that subscribers to the Observable cannot mutate the original object
 *
 * @param source$ The source observable.
 * @returns The cloned object.
 */
export function deepClone<T>(source$: Observable<T>): Observable<T> {
    return source$.pipe(map(data => structuredClone(data)));
}
